<template>
  <div>
    <router-view :key="lang"></router-view>
  </div>
</template>

<script>

import Vue from "vue";
import { TranslationService, CookieService, AppService } from "@/services";

export default {
  name: "app",
  data() {
    return {
      translationService: new TranslationService,
      appService: new AppService,
      cookieService: new CookieService,
      lang: null,
      release: null,
    }
  },
  mounted() {
    this.initLanguageWatcher();

    this.appService.findReleaseNumber().then((data) => {
      const iso = this.$store.state?.user?.preference?.language?.iso_3166_2 || localStorage.getItem('locale');
      const release = localStorage.getItem('release');

      if (release != data.release) {
        localStorage.setItem('release', data.release);
        this.cookieService.removeCookie('lang');
      }

      if (iso) {
        this.fetchLanguage(iso);
      } else {
        // set language accoding to browser language
        const iso = navigator.language.substr(0, 2);
        this.fetchLanguage(iso, true);
      }
    })
  },
  methods: {
    initLanguageWatcher() {
      this.$watch(
        function () {
          return this.$store.state?.user?.preference?.language?.iso_3166_2;
        },
        function (newVal, oldVal) {
          this.cookieService.removeCookie('lang');

          if (newVal) {
            window.axios.defaults.headers.common['X-Locale'] = newVal;

            this.fetchLanguage(newVal)
          }
        }
      )
    },
    fetchLanguage(isoCode, reload) {
      return this.translationService.findByIso(isoCode).then(data => {
        this.cookieService.setCookie(`lang`, isoCode, 365);
        localStorage.setItem('i18n', JSON.stringify(data));
        localStorage.setItem('locale', isoCode);
        window.i18n = data;
        Vue.prototype.i18n = data;
        this.lang = isoCode;
        if (reload) {
          location.reload();
        }
        this.$forceUpdate();
      })
    }
  }
};
</script>
